import createVuexStore from '../../store/store';

const store = createVuexStore();

const getBasePath = (route) => (
  `/${route.params.locale}/exchange/${
    route.query.exchangeType && route.query.exchangeId
      ? `?${new URLSearchParams(route.query).toString()}`
      : ''
  }`
);
const canProceed = () => store.state.customer.deviceVerificationResponse;
const alreadyHome = (route) => route.fullPath === getBasePath(route);
export default (to, from, next) => {
  if (!canProceed() && !alreadyHome(to)) {
    next(getBasePath(to));
  } else next();
};
